export const ugovor_o_radu_odredjeno_dodatno = {
  templateId: 4,
  category: 1,
  templateTitle: "Ugovor o radu na određeno vrijeme, bez pravilnika o radu i kolektivnog ugovora, uključuje dodatne odredbe",
  templateDescription: `<p>Ugovor se primjenjuje na radne odnose Poslodavca i Radnika u slučaju da kod Poslodavca nije donesen pravilnik o radu te se na radni odnos ne primjenjuje Kolektivni ugovor.</p>`,
  description: `
    <h5>OPIS DOKUMENTA</h5>
    <p>Ovaj tekst, kao i dolje navedeni primjer ugovora o radu odnose se na situacije u kojima poslodavac zapošljava manje od dvadeset radnika te kod poslodavca nije donesen pravilnik o radu (obveza poslodavca koji zapošljava 20 i više radnika).</p>
    <p>Ugovor o radu  je dvostrano obvezni ugovor prema kojemu je poslodavac dužan radniku dati posao i za obavljeni rad mu isplatiti plaću, a radnik je dužan osobno obavljati preuzeti posao prema uputama poslodavca.</p>
    <p>Radni odnos zasniva se na neodređeno vrijeme, no iznimno se može zasnovati i na određeno vrijeme, uz pridržavanje zakonskih odredbi.</p>
    <p>Prikazani primjerak ugovora o radu na <strong>određeno</strong> vrijeme uključuje i dodatne odredbe o međusobnim pravima koje nisu zakonski nužne, no svakako su korisne za reguliranje prava i obveza iz radnog odnosa.</p>
    <p>U slučaju da je određeno pravo drugačije uređeno Zakonom o radu, Ugovorom o radu, pravilnikom o radu ili kolektivnim ugovorom, uvijek primjenjuje najpovoljnije pravo za radnika.</p>
    <p>Takav primjerak ugovora na određeno vrijeme koji sadrži osnovne odredbe možete pogledati <a class="local-link" href="/contract?template=3">ovdje</a>.</p>
    <p><strong>Ovaj tekst će biti nešto duži iz razloga što su greške kod sklapanja ovog ugovora u radu na određeno vrijeme najčešći razlog pokretanja prekršajnih postupaka i kažnjavanja u postupcima pred sudom.</strong></p>
    <p>Zakonom o radu je propisano da se ugovor o radu može <strong>iznimno</strong> sklopiti na određeno vrijeme, za zasnivanje radnog odnosa čiji je prestanak unaprijed utvrđen <strong>rokom, izvršenjem određenog posla ili nastupanjem određenog događaja.</strong></p>
    <p>Uzastopni ugovor o radu na određeno vrijeme može se sklopiti samo ako za to postoji objektivan razlog, koji se mora navesti u ugovoru u radu ili potvrdi o sklopljenom ugovoru o radu.</p>
    <p><strong>Razni primjeri rokova ili događaja odnosno objektivnih razloga za sklapanje ugovora o radu na određeno izlažu se u čl. 1. dolje prikazanog ugovora o radu.</strong></p>
    <p>Važno je reći da se svaka izmjena, odnosno dopuna ugovora o radu na određeno vrijeme, točnije svaki Aneks Ugovoru o radu na određeno vrijeme koji bi utjecao na produljenje ugovorenog trajanja toga ugovora, smatra sljedećim uzastopnim ugovorom o radu na određeno vrijeme (novim ugovorom).</p>
    <p>U tom smislu, svejedno je da li se ugovor produljuje aneksom ugovora o radu na određeno vrijeme ili novim ugovorom o radu na određeno vrijeme.</p>
    <p>Ukupno trajanje svih uzastopnih ugovora o radu sklopljenih na određeno vrijeme, uključujući i prvi ugovor o radu, ne smije biti neprekinuto duže od tri godine (prekid kraći od 2 mjeseca se ne smatra prekidom tog razdoblja), osim ako je to potrebno zbog zamjene privremeno nenazočnog radnika ili je zbog nekih drugih objektivnih razloga dopušteno zakonom ili kolektivnim ugovorom.</p>
    <p><strong>Međutim, zakonom je propisan izuzetak koji propisuje da ako je sklopljen jedan ugovor o radu na određeno vrijeme (nije sklopljen sljedeći uzastupni ugovor), tada isti može biti sklopljen bez navođenja objektivnog razloga u ugovoru i isti može trajati duže od 3 godine.  Iako sklapanje prvog ugovora o radu na određeno bez navođenja objektivnog razloga nije prekršaj,  radi izbjegavanja sporova radnika i poslodavca te mogućih raznih tumačenja inspekcijskih tijela, predlaže se i u prvom ugovoru o radu na određeno vrijeme navesti objektivni razlog za sklapanje ugovora o radu na određeno vrijeme.</strong></p>
    <p><strong>U protivnom, ukoliko je ugovor o radu na određeno vrijeme sklopljen protivno odredbama Zakona o radu, smatra se da je sklopljen ugovor o radu na neodređeno vrijeme.</strong></p>
    <p>Također, ako ugovorom o radu,  vrijeme na koje je sklopljen nije određeno ili ako radnik nakon isteka ugovora o radu na određeno nastavi raditi za poslodavca, smatra se da je sklopljen ugovor o radu na neodređeno vrijeme.</p>
    <p><strong>Ugovor o radu sklopljen na određeno vrijeme može se redovito otkazati samo ako je takva mogućnost otkazivanja predviđena ugovorom.</strong></p>
    <p>U slučaju isteka roka ugovora o radu na određeno vrijeme ili prestanka potrebe uslijed izvršenja određenog posla ili nastupanja određenog događaja zbog kojih je ugovor o radu na određeno sklopljen, ne dolazi do otkazu ugovora o radu na određeno vrijeme, nego se radi o isteku ugovora o radu na određeno vrijeme.</p> 
    <p>Prikazani primjerak ugovora u radu zaključuje se između poslodavca i radnika u slučaju da kod poslodavca nije donesen pravilnik o radu te kad se na radni odnos ne primjenjuju odredbe određenog kolektivnog ugovora.</p>
    <p>Popis kolektivnih ugovora s proširenom primjenom pogledajte <a target="_blank" href="http://www.mrms.hr/ministarstvo-rada-i-mirovinskoga-sustava/socijalno-partnerstvo/katalog-zakona-i-propisa/popis-prosirenih-kolektivnih-ugovora/">ovdje</a>.</p>
    <h5>SVRHA DOKUMENTA</h5>
    <p>Ugovorne strane Ugovorom o radu reguliraju svoja međusobna prava i obveze.</p>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Ugovor o radu ne sadrži sve bitne sastojke određene ugovorom o radu - prekršaj</strong></p>
    <p>Pojašnjenje: bitni sastojci Ugovora o radu određeni su Zakonom o radu.</p>
    <p><strong>- Sklapanje ugovora o radu na određeno vrijeme za poslove koji nisu zakonom navedeni poslovi zbog kojih se može zaključiti Ugovor o radu na određeno vrijeme</strong></p>
    <p>Pojašnjenje: ugovor o radu na određeno vrijeme može se sklopiti samo za zasnivanje radnog odnosa čiji je prestanak unaprijed utvrđen rokom, izvršenjem određenog posla ili nastupanjem određenog događaja. Ukoliko nije ispunjen taj uvjet, smatra se da je sklopljen ugovor o radu  na neodređeno vrijeme, osim ako se radi o prvom ugovoru na određeno vrijeme poslije kojega poslodavac nije sklopio sljedeći uzastopni ugovor na određeno.</p>
    <p><strong>- Ako ugovorom o radu na određeno vrijeme nije određeno vrijeme na koji je sklopljen</strong></p>
    <p>Pojašnjenje:Ako ugovorom o radu nije određeno vrijeme na koje je sklopljen, smatra se da je sklopljen ugovor o radu na neodređeno vrijeme.</p>
    <p><strong>- Ako poslodavac s istim radnikom sklopi uzastopni ugovor o radu na određeno vrijeme za koji ne postoji objektivan razlog - prekršaj</strong></p>
    <p>Pojašnjenje: uzastopni ugovor o radu mora imati u ugovoru naveden objektivan razlog te se isti u slučaju potrebe mora pojasniti/dokazati inspekcijskim tijelima/sudu. Produljenje ugovora smatra se novim/uzastopnim ugovorom o radu.</p>
    <p><strong>- Ako u uzastopnom ugovoru o radu na određeno ili u pisanoj potvrdi o sklopljenom ugovoru o radu ne navede objektivan razlog - prekršaj</strong></p>
    <p>Pojašnjenje: objektivni razlog za sklapanje Ugovora o radu na određeno vrijeme mora biti naveden u samom ugovoru o radu na određeno vrijeme ili u potvrdi o sklopljenom ugovoru o radu na određeno vrijeme. Produljenje ugovora smatra se novim/uzastopnim ugovorom o radu.</p>
    <p><strong>-  Ako trajanje svih uzastopnih ugovora o radu sklopljenih na određeno vrijeme, uključujući i prvi ugovor o radu, traje neprekinuto duže od tri godine, osim ako je to potrebno zbog zamjene privremeno nenazočnog radnika ili je zbog nekog drugog objektivnog razloga dopušteno zakonom ili kolektivnim ugovorom - prekršaj</strong></p>
    <p>Pojašnjenje: postupanje protivno navedenom predstavlja prekršaj, stoga treba pratiti istek ugovora o radu na određeno vrijeme.</p>
    <p><strong>- Nastavak rada i nakon isteka Ugovora o radu na određeno vrijeme</strong></p>
    <p>Pojašnjenje:  ako radnik nastavi raditi kod poslodavca i nakon isteka vremena za koje je ugovor sklopljen, smatra se da je sklopljen ugovor o radu na neodređeno vrijeme.
    <p><strong>- Neugovaranje mogućnosti  redovitog otkaza ugovora o radu na određeno</strong></p>
    <p>Pojašnjenje: u slučaju da ugovor o radu na određeno vrijeme ne sadrži odredbu prema kojoj ugovorne strane mogu redovito otkazati ugovor o radu na određeno vrijeme, ugovorne strane neće moći otkazati takav ugovor redovitim putem.</p>
    <p><strong>- Davanje otkaza ugovora o radu na određeno vrijeme koji se pogrešno upućuje radniku uslijed isteka roka na koji je ugovor sklopljen ili  davanje otkaza ugovora u slučaju prestanka potrebe uslijed izvršenja određenog posla ili nastupanja određenog događaja</strong></p>
    <p>Pojašnjenje: poslodavac nije dužan obavijestiti radnika o isteku ugovora na određeno vrijeme niti ga je dužan obavijestiti da ne želi produžiti (sklopiti novi) ugovor na određeno vrijeme, tj. takva obveza poslodavca nije određena odredbama Zakona o radu. Ipak, Hrvatski zavod za zapošljavanje ponekad traži dokument na temelju kojega može utvrditi prestanak potrebe te u tom slučaju poslodavac može jedino izdati potvrdu kojom potvrđuje da je ugovor o radu na određeno vrijeme prestao na određeni dan,  uslijed prestanka prestankom potrebe za njegovim radom. Svrha izdavanja takve potvrde je ostvarivanje prava za nezaposlene osobe pri Zavodu za zapošljavanje <strong>te se ista svakako ne smatra otkazom</strong> stoga ne bi smjela imati nikakve odredbe koji spominju otkaz ugovora o radu na određeno vrijeme i sl..</p>
    <p><strong>- Ugovor o radu izrađen je citiranjem odredaba Zakona o radu koji je prestao važiti</strong></p>
    <p>Pojašnjenje: stvara se dvojba u pravima i obvezama ugovornih strana.</p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o radu.</p>
  `,

  sides: [
    {
      prefix: "Na temelju odredaba Zakona o radu,",
      signature: "Za Poslodavca:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: " (u daljnjem tekstu: Poslodavac)",
      delimiter: `i`
    },
    {
      signature: "Radnik:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Ime i prezime",
        label: "Ime i prezime",
        inSignature: true,
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      ],
      suffix: " (u daljnjem tekstu: Radnik),"
    }
  ],

  headline: "zaključuju sljedeći",
  title: "UGOVOR O RADU NA ODREĐENO VRIJEME",

  articles: [
    {
      title: "VRSTA UGOVORA",
      mandatory: true,
      exampleContent: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru, uslijed povećane potrebe za poljoprivrednim radovima u proizvodnoj sezoni ratarskih kultura roda" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine, a koji poslovi traju najkasnije do" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine.", help: "Za uzastopne ugovore o radu (drugi i svaki sljedeći) na određeno vrijemo mora biti naveden objektivni razlog sklapanja ugovora (prestanak unaprijed određen rokom, izvršenjem određenog posla ili nastupanjem određenog događaja) te isti mora biti osnovan i dokaziv. Iako sklapanje prvog ugovora o radu na određeno vrijeme bez navođenja objektivnog razloga nije prekršaj, radi izbjegavanja sporova radnika i poslodavca te mogućih raznih tumačenja inspekcijskih tijela, predlaže se i u prvom ugovoru o radu na određeno vrijeme navesti objektivni razlog za sklapanje ugovora o radu na određeno vrijeme. Ukoliko ugovor o radu nije sklopljen do točno određenog dana prijedlog je da se prije trenutka kada će prestati potreba za obavljanjem poslova, radniku uruči Obavijest o prestanku potrebe za radom radnika na temelju koje će radni odnos radnika prestati – navedena obavijest se ne smatra otkazom ugovora o radu!" },
              ]
            },
            {
              parts: [
                { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru, uslijed povećane potrebe za radom tijekom trajanja ljetne turističke sezone" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine, a koji poslovi traju najkasnije do" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine.", help: "Za uzastopne ugovore o radu (drugi i svaki sljedeći) na određeno vrijemo mora biti naveden objektivni razlog sklapanja ugovora (prestanak unaprijed određen rokom, izvršenjem određenog posla ili nastupanjem određenog događaja) te isti mora biti osnovan i dokaziv. Iako sklapanje prvog ugovora o radu na određeno vrijeme bez navođenja objektivnog razloga nije prekršaj, radi izbjegavanja sporova radnika i poslodavca te mogućih raznih tumačenja inspekcijskih tijela, predlaže se i u prvom ugovoru o radu na određeno vrijeme navesti objektivni razlog za sklapanje ugovora o radu na određeno vrijeme. Ukoliko ugovor o radu nije sklopljen do točno određenog dana prijedlog je da se prije trenutka kada će prestati potreba za obavljanjem poslova, radniku uruči Obavijest o prestanku potrebe za radom radnika na temelju koje će radni odnos radnika prestati – navedena obavijest se ne smatra otkazom ugovora o radu!" },
              ]
            },
            {
              parts: [
                { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru, uslijed povećane potrebe za radom uzrokavane novim narudžbama sljedećih kupaca" },
                { type: "input", value: "", required: true },
                { type: "text", content: ", a koji poslovi traju najkasnije do" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine.", help: "Za uzastopne ugovore o radu (drugi i svaki sljedeći) na određeno vrijemo mora biti naveden objektivni razlog sklapanja ugovora (prestanak unaprijed određen rokom, izvršenjem određenog posla ili nastupanjem određenog događaja) te isti mora biti osnovan i dokaziv. Iako sklapanje prvog ugovora o radu na određeno vrijeme bez navođenja objektivnog razloga nije prekršaj, radi izbjegavanja sporova radnika i poslodavca te mogućih raznih tumačenja inspekcijskih tijela, predlaže se i u prvom ugovoru o radu na određeno vrijeme navesti objektivni razlog za sklapanje ugovora o radu na određeno vrijeme. Ukoliko ugovor o radu nije sklopljen do točno određenog dana prijedlog je da se prije trenutka kada će prestati potreba za obavljanjem poslova, radniku uruči Obavijest o prestanku potrebe za radom radnika na temelju koje će radni odnos radnika prestati – navedena obavijest se ne smatra otkazom ugovora o radu!" },
              ]
            },
            {
              parts: [
                { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru, uslijed sezone izlova plave ribe,  a koji poslovi traju najkasnije do" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine.", help: "Za uzastopne ugovore o radu (drugi i svaki sljedeći) na određeno vrijemo mora biti naveden objektivni razlog sklapanja ugovora (prestanak unaprijed određen rokom, izvršenjem određenog posla ili nastupanjem određenog događaja) te isti mora biti osnovan i dokaziv. Iako sklapanje prvog ugovora o radu na određeno vrijeme bez navođenja objektivnog razloga nije prekršaj, radi izbjegavanja sporova radnika i poslodavca te mogućih raznih tumačenja inspekcijskih tijela, predlaže se i u prvom ugovoru o radu na određeno vrijeme navesti objektivni razlog za sklapanje ugovora o radu na određeno vrijeme. Ukoliko ugovor o radu nije sklopljen do točno određenog dana prijedlog je da se prije trenutka kada će prestati potreba za obavljanjem poslova, radniku uruči Obavijest o prestanku potrebe za radom radnika na temelju koje će radni odnos radnika prestati – navedena obavijest se ne smatra otkazom ugovora o radu!" },
              ]
            },
            {
              parts: [
                { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru, do povratka na posao djelatnika zaposlenom na radnom mjestu" },
                { type: "input", value: "", required: true },
                { type: "text", content: ", a koji je privremeno nenazočan uslijed privremene nesposobnosti za rad.", help: "Za uzastopne ugovore o radu (drugi i svaki sljedeći) na određeno vrijemo mora biti naveden objektivni razlog sklapanja ugovora (prestanak unaprijed određen rokom, izvršenjem određenog posla ili nastupanjem određenog događaja) te isti mora biti osnovan i dokaziv. Iako sklapanje prvog ugovora o radu na određeno vrijeme bez navođenja objektivnog razloga nije prekršaj, radi izbjegavanja sporova radnika i poslodavca te mogućih raznih tumačenja inspekcijskih tijela, predlaže se i u prvom ugovoru o radu na određeno vrijeme navesti objektivni razlog za sklapanje ugovora o radu na određeno vrijeme. Ukoliko ugovor o radu nije sklopljen do točno određenog dana prijedlog je da se prije trenutka kada će prestati potreba za obavljanjem poslova, radniku uruči Obavijest o prestanku potrebe za radom radnika na temelju koje će radni odnos radnika prestati – navedena obavijest se ne smatra otkazom ugovora o radu!" },
              ]
            },
            {
              parts: [
                { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru, do povratka na posao djelatnika zaposlenom na radnom mjestu" },
                { type: "input", value: "", required: true },
                { type: "text", content: ", a koji je privremeno nenazočan uslijed korištenja rodiljnog/roditeljskog dopusta.", help: "Za uzastopne ugovore o radu (drugi i svaki sljedeći) na određeno vrijemo mora biti naveden objektivni razlog sklapanja ugovora (prestanak unaprijed određen rokom, izvršenjem određenog posla ili nastupanjem određenog događaja) te isti mora biti osnovan i dokaziv. Iako sklapanje prvog ugovora o radu na određeno vrijeme bez navođenja objektivnog razloga nije prekršaj, radi izbjegavanja sporova radnika i poslodavca te mogućih raznih tumačenja inspekcijskih tijela, predlaže se i u prvom ugovoru o radu na određeno vrijeme navesti objektivni razlog za sklapanje ugovora o radu na određeno vrijeme. Ukoliko ugovor o radu nije sklopljen do točno određenog dana prijedlog je da se prije trenutka kada će prestati potreba za obavljanjem poslova, radniku uruči Obavijest o prestanku potrebe za radom radnika na temelju koje će radni odnos radnika prestati – navedena obavijest se ne smatra otkazom ugovora o radu!" },
              ]
            },
            {
              parts: [
                { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru, uslijed povećane potrebe rada vezane za pripremu strojeva i proizvodnog pogona uzrokovanih povećanjem proizvodnje u proizvodnoj sezoni" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine, a koji poslovi traju najkasnije do" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine.", help: "Za uzastopne ugovore o radu (drugi i svaki sljedeći) na određeno vrijemo mora biti naveden objektivni razlog sklapanja ugovora (prestanak unaprijed određen rokom, izvršenjem određenog posla ili nastupanjem određenog događaja) te isti mora biti osnovan i dokaziv. Iako sklapanje prvog ugovora o radu na određeno vrijeme bez navođenja objektivnog razloga nije prekršaj, radi izbjegavanja sporova radnika i poslodavca te mogućih raznih tumačenja inspekcijskih tijela, predlaže se i u prvom ugovoru o radu na određeno vrijeme navesti objektivni razlog za sklapanje ugovora o radu na određeno vrijeme. Ukoliko ugovor o radu nije sklopljen do točno određenog dana prijedlog je da se prije trenutka kada će prestati potreba za obavljanjem poslova, radniku uruči Obavijest o prestanku potrebe za radom radnika na temelju koje će radni odnos radnika prestati – navedena obavijest se ne smatra otkazom ugovora o radu!" },
              ]
            },
            {
              parts: [
                { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru, uslijed povećane potrebe za radom radi redovitog remonta" },
                { type: "input", value: "", required: true },
                { type: "text", content: ", a koji poslovi traju najkasnije do" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine.", help: "Za uzastopne ugovore o radu (drugi i svaki sljedeći) na određeno vrijemo mora biti naveden objektivni razlog sklapanja ugovora (prestanak unaprijed određen rokom, izvršenjem određenog posla ili nastupanjem određenog događaja) te isti mora biti osnovan i dokaziv. Iako sklapanje prvog ugovora o radu na određeno vrijeme bez navođenja objektivnog razloga nije prekršaj, radi izbjegavanja sporova radnika i poslodavca te mogućih raznih tumačenja inspekcijskih tijela, predlaže se i u prvom ugovoru o radu na određeno vrijeme navesti objektivni razlog za sklapanje ugovora o radu na određeno vrijeme. Ukoliko ugovor o radu nije sklopljen do točno određenog dana prijedlog je da se prije trenutka kada će prestati potreba za obavljanjem poslova, radniku uruči Obavijest o prestanku potrebe za radom radnika na temelju koje će radni odnos radnika prestati – navedena obavijest se ne smatra otkazom ugovora o radu!" },
              ]
            },
            {
              parts: [
                { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru, uslijed povećane potrebe za radom radi redovitog remonta" },
                { type: "input", value: "", required: true },
                { type: "text", content: ", a koji poslovi traju najkasnije do" },
                { type: "input", value: "", required: true },
                { type: "text", content: "godine.", help: "Za uzastopne ugovore o radu (drugi i svaki sljedeći) na određeno vrijemo mora biti naveden objektivni razlog sklapanja ugovora (prestanak unaprijed određen rokom, izvršenjem određenog posla ili nastupanjem određenog događaja) te isti mora biti osnovan i dokaziv. Iako sklapanje prvog ugovora o radu na određeno vrijeme bez navođenja objektivnog razloga nije prekršaj, radi izbjegavanja sporova radnika i poslodavca te mogućih raznih tumačenja inspekcijskih tijela, predlaže se i u prvom ugovoru o radu na određeno vrijeme navesti objektivni razlog za sklapanje ugovora o radu na određeno vrijeme. Ukoliko ugovor o radu nije sklopljen do točno određenog dana prijedlog je da se prije trenutka kada će prestati potreba za obavljanjem poslova, radniku uruči Obavijest o prestanku potrebe za radom radnika na temelju koje će radni odnos radnika prestati – navedena obavijest se ne smatra otkazom ugovora o radu!" },
              ]
            },
          {
            parts: [
              { type: "text", content: "Ovim se Ugovorom između Poslodavca i Radnika zasniva radni odnos na određeno vrijeme za obavljanje poslova na radnom mjestu navedenom u ovom Ugovoru, uslijed:" },
              { type: "textarea", content: "" },
              { help: 'S obzirom na gore prikazane primjere rokova ili događaja odnosno objektivnih razloga za sklapanje ugovora o radu na određeno, ovdje samostalno upisujete prethodno navedeno - objektivni razlog sklapanja ugovora.'}
            ]
          }
        ],
        value: "",
      },
    ]
  },
    {
      title: "PROBNI RAD",
      mandatory: false,
      exampleContent: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Ugovorne strane sklapaju ovaj Ugovor uz uvjet probnog rada Radnika u trajanju od šest mjeseci, uz otkazni rok određen Zakonom o radu i Pravilnikom o radu.",
          help: "Probni rad je zakonski dopušten u trajanju od najviše 6 mjeseci.",
        },
      ]
    },
    {
      title: "RADNO MJESTO",
      mandatory: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Radnik će za Poslodavca obavljati poslove na radnom mjestu " },
                { type: "input", value: "", required: true, help: "Unijeti naziv radnog mjesta." },
              ]
            },
            {
              parts: [
                { type: "text", content: "Radnik će za Poslodavca obavljati poslove na radnom mjestu " },
                { type: "input", value: "", required: true, help: "Unijeti naziv radnog mjesta." },
                { type: "text", content: ", kao i sve druge poslove po neposrednom nalogu Poslodavca." },
              ]
            },
            {
              parts: [
                { type: "text", content: "Radnik će za Poslodavca obavljati poslove na radnom mjestu " },
                { type: "input", value: "", required: true, help: "Unijeti naziv radnog mjesta." },
                { type: "text", content: ", a koji poslovi uključuju sljedeće zadatke i odgovornosti:" },
                { type: "textarea", value: "", required: true, help: "Upisati opis radnog mjesta - zadatke i odgovornosti." },
              ]
            }
        ],
        value: "",
      },
    ]
  },
    {
      title: "MJESTO RADA",
      mandatory: true,
      statements: [{
        type: "choice",
        mandatory: true,
        editable: false,
        choices: [
          {
            parts: [
              { type: "text", content: "Radnik će poslove koji su predmet ovog Ugovora obavljati u sjedištu Poslodavca, a po potrebi i na drugim mjestima gdje Poslodavac obavlja svoje poslovanje i ima svoje ispostave." },
            ]
          },
          {
            parts: [
              { type: "text", content: "Radnik će poslove koji su predmet ovog Ugovora obavljati u " },
              { type: "input", value: "", required: true },
              { type: "text", content: ", a po potrebi i na drugim mjestima gdje Poslodavac obavlja svoje poslovanje i ima svoje ispostave." },
            ]
          },
          {
            parts: [
              { type: "text", content: "Radnik će poslove koji su predmet ovog Ugovora obavljati na različitim mjestima." },
            ]
          },],
        value: "",
      }]
    },
    {
      title: "POČETAK RADA",
      mandatory: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            { type: "text", content: "Radnik će početi s radom dana " },
            { type: "input", value: "", required: true, help: "Prijava radnika tijelima mirovinskog osiguranja mora biti obavljena prije početka rada, stoga se predlaže da datum sklapanja ugovora bude prije datuma početka rada." },
            { type: "text", content: "godine. " }],
        }
      ]
    },
    {
      title: "TRAJANJE REDOVITOG RADNOG TJEDNA/DANA",
      mandatory: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Radnik će raditi u punom radnom vremenu, u trajanju od 40 sati tjedno." },
              ]
            },
            {
              parts: [
                { type: "text", content: "Radnik će raditi u nepunom radnom vremenu, u trajanju od " },
                { type: "input", value: "", required: true },
                { type: "text", content: "sati tjedno." },
              ]
            },
            {
              parts: [
                { type: "text", content: "Radnik će raditi u radnom vremenu, u trajanju od " },
                { type: "input", value: "", required: true },
                { type: "text", content: "sati dnevno." },
              ]
            }],
          value: "",
        }
      ]
    },
    {
      title: "RASPORED RADNOG VREMENA",
      mandatory: false,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Radno vrijeme je jednokratno te je raspoređeno u 5 (pet) dana u tjednu, tako da od" },
                { type: "input", value: "", required: true },
                { type: "text", content: "do" },
                { type: "input", value: "", required: true },
                { type: "text", content: "svakim danom počinje u" },
                { type: "input", value: "", required: true },
                { type: "text", content: "sati, a završava u" },
                { type: "input", value: "", required: true },
                { type: "text", content: "sati, osim ako se odlukom o rasporedu radnog vremena ne odredi drugačije.", help: "Raspored radnog vremena utvrđuje se propisom, kolektivnim ugovorom, sporazumom sklopljenim između radničkog vijeća i poslodavca, pravilnikom o radu ili ugovorom o radu. Ako raspored radnog vremena nije utvrđen na prethodno opisani način, o rasporedu radnog vremena odlučuje poslodavac pisanom odlukom." },
              ]
            },
            {
              parts: [
                { type: "text", content: "Radno vrijeme je jednokratno te je raspoređeno u 6 (šest) dana u tjednu, tako da " },
                { type: "input", value: "", required: true },
                { type: "text", content: "počinje u" },
                { type: "input", value: "", required: true },
                { type: "text", content: "sati i završava u" },
                { type: "input", value: "", required: true },
                { type: "text", content: "sati, a" },
                { type: "input", value: "", required: true },
                { type: "text", content: "počinje u" },
                { type: "input", value: "", required: true },
                { type: "text", content: "sati i završava u" },
                { type: "input", value: "", required: true },
                { type: "text", content: "sati, " },
                { type: "text", content: "a osim ako se odlukom o rasporedu radnog vremena ne odredi drugačije.", help: "Raspored radnog vremena utvrđuje se propisom, kolektivnim ugovorom, sporazumom sklopljenim između radničkog vijeća i poslodavca, pravilnikom o radu ili ugovorom o radu. Ako raspored radnog vremena nije utvrđen na prethodno opisani način, o rasporedu radnog vremena odlučuje poslodavac pisanom odlukom." },
              ]
            }],
          value: "",
        }
      ]
    },
    {
      title: "STANKA, DNEVNI I TJEDNI ODMOR",
      mandatory: false,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: true,
          choices: [
            "Radnik će koristiti stanku, dnevni odmor i tjedni odmor sukladno Zakonu o radu.",
            "Pravo radnika na stanku, dnevni i tjedni odmor određeno je posebnom Odlukom poslodavca.",
            "Radnik će imati pravo na stanku od 30 minuta dnevno, a dnevni i tjedni odmor će koristiti subotom i nedjeljom."
          ],
          placeholder: "Odaberite ovdje te potom izmijenite po želji...",
        }]
    },
    {
      title: "GODIŠNJI ODMOR",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Radnik ima pravo na godišnji odmor sukladno važećim odredbama Zakona o radu.",
        },
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "\r\nZa vrijeme korištenja godišnjeg odmora, Radnik ima pravo na naknadu plaće, najmanje u visini njegove prosječne mjesečne plaće u prethodna tri mjeseca.",
        },
      ]
    },
    {
      title: "OTKAZ UGOVORA",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Ugovorne strane mogu ovaj Ugovor o radu redovito otkazati sukladno važećim odredbama Zakona o radu.",
        },
      ]
    },
    {
      title: "PLAĆA",
      mandatory: true,
      statements: [
        {
          type: "input",
          mandatory: true,
          editable: false,
          parts: [
            { type: "text", content: "Za obavljanje poslova iz ovog Ugovora, Poslodavac će Radniku isplaćivati osnovnu plaću u iznosu od najmanje " },
            { type: "input", value: "", required: true },
            { type: "text", content: "kuna bruto.", help: "Radniku se ne smije isplatiti plaća manja od minimalne plaće. Minimalna plaća je najniži mjesečni iznos bruto plaće koji radniku pripada za rad u punom radnom vremenu. Visinu minimalne plaće uredbom utvrđuje Vlada Republike Hrvatske, na prijedlog ministra nadležnog za rad. Pod bruto plaćom se podrazumijeva bruto 1 iznos." }],

        }
      ]
    },
    {
      title: "DODACI NA PLAĆU",
      mandatory: true,
      statements: [
      
        {
          type: "input",
          editable: false,
          mandatory: true,
          parts: [
        
            {type: "text", content: "Osim plaće, Radnik ima pravo i na sljedeće dodatke na plaću:"},
            { type: "text", newline:"true", content: "\r\n- za otežane uvjete rada: " },
            { type: "input", value: "", required: true },
            { type: "text", content: "%,", help: "Postotak ovog povećanja te ostalih povećanja u ovom članku nije određen Zakonom, stoga je moguće ugovoriti povećanje od 1% na više."},
            { type: "text", newline:"true", content: "\r\n- za noćni rad:" },
            { type: "input", value: "", required: true },
            { type: "text", content: "%," },
            { type: "text", newline:"true", content: "\r\n- za prekovremeni rad: " },
            { type: "input", value: "", required: true },
            { type: "text", content: "%," },
            { type: "text", newline:"true", content: "\r\n- za rad nedjeljom, blagdanom ili nekim drugim danom za koji je zakonom određeno da se ne radi: " },
            { type: "input", value: "", required: true },
            { type: "text", content: "%." }],

          }
        ]
      },
    {
      title: "RAZDOBLJE ISPLATE PLAĆE",
      mandatory: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Poslodavac će isplaćivati plaću te eventualna ostala primanja na koja Radnik ima pravo, jednom mjesečno i to najkasnije do zadnjeg dana tekućeg mjeseca za prethodni mjesec." },
              ]
            },
            {
              parts: [
                { type: "text", content: "Poslodavac će isplaćivati plaću te eventualna ostala primanja na koja Radnik ima pravo, jednom mjesečno i to najkasnije do " },
                { type: "input", value: "", required: true },
                { type: "text", content: "–og dana u mjesecu za prethodni mjesec." },
              ]
            }],
          value: "",
        }
      ]
    },
    {
      title: "UPOZNAVANJE S ORGANIZACIJOM RADA",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Radnik svojim potpisom potvrđuje da mu je Poslodavac omogućio da se upozna s propisima u vezi s radnim odnosima  te da ga je upoznao s organizacijom rada i zaštitom zdravlja i sigurnosti na radu.",
          help: "Prema Zakonu o radu, prije stupanja Radnika na rad, poslodavac je dužan omogućiti Radniku da se upozna s propisima u vezi s radnim odnosima te ga je dužan upoznati s organizacijom rada i zaštitom zdravlja i sigurnosti na radu."
        },
      ]
    },
    {
      title: "OBVEZE RADNIKA",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          required: true,
          editable: true,
          content: "Radnik se obvezuje prilikom izvršavanja obveza i prava koji proizlaze iz ovog Ugovora postupati savjesno, odgovorno i stručno, sukladno naravi i vrsti posla, zakonskim i podzakonskim propisima i pravilima struke te s pažnjom dobrog gospodarstvenika, odano i vjerno zastupati interese Poslodavca odnosno čuvati i promicati njegov poslovni ugled.",
        },
      ]
    },
    {
      title: "ZAKONSKA ZABRANA NATJECANJA",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          required: true,
          editable: true,
          content: `Radnik ne smije bez odobrenja Poslodavca, za svoj ili tuđi račun, sklapati poslove iz djelatnosti koju obavlja Poslodavac (zakonska zabrana natjecanja), a osobito ne smije osnovati društvo koje bi bilo u posrednoj ili neposrednoj tržišnoj utakmici s Poslodavcem, stjecati dionice ili udjele u takvome društvu te na bilo koji način sudjelovati u radu konkurentskog društva.\r\nAko Radnik postupi protivno zabrani iz stavka 1. ovoga članka, Poslodavac može od Radnika tražiti naknadu pretrpljene štete ili može tražiti da se sklopljeni posao smatra sklopljenim za njegov račun, odnosno da mu Radnik preda zaradu ostvarenu iz takvoga posla ili da na njega prenese potraživanje zarade iz takvoga posla.`,
          help: "Zakonska zabrana natjecanja obvezuje Poslodavca i Radnika bez obzira da li je ugovorena ili ne."
        }]
    },
    {
      title: "UGOVORNA ZABRANA NATJECANJA",
      mandatory: false,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Radnik svojim potpisom potvrđuje da se u vrijeme zasnivanja radnog odnosa s Poslodavcem ne bavi obavljanjem poslova iz djelatnosti Poslodavca." },
                { type: "text", content: "Radnik se obvezuje da se neće u razdoblju od dvije godine nakon prestanka ugovora o radu zaposliti kod druge osobe koja je u tržišnom natjecanju s Poslodavcem te da neće za svoj račun ili za račun treće osobe sklapati poslove kojima se natječe s Poslodavcem." },
                { type: "text", content: "Poslodavac će za vrijeme zabrane natjecanja isplaćivati Radniku naknadu najmanje u iznosu polovice prosječne plaće isplaćene Radniku u tri mjeseca prije prestanka ugovora o radu." },
                { type: "text", content: "Ukoliko Radnik prekrši ugovornu zabranu natjecanja, Poslodavac ima pravo tražiti od Radnika naknadu pretrpljene štete ili može tražiti da se sklopljeni posao smatra sklopljenim za njegov račun, odnosno da mu Radnik preda zaradu ostvarenu iz takvoga posla ili da na njega prenese potraživanje zarade iz takvoga posla.", help: "Ugovorna zabrana natjecanja je ništetna (ne proizvodi pravne učinke) ako  istu sklopi maloljetnik ili radnik koji u vrijeme sklapanja toga ugovora prima plaću manju od prosječne plaće u Republici Hrvatskoj. Ugovorna zabrana natjecanja ne smije trajati duže od dvije godine nakon prestanka ugovora o radu. Ugovorna zabrana natjecanja obvezuje radnika samo ako je poslodavac ugovorom preuzeo obvezu da će radniku za vrijeme trajanja zabrane isplaćivati naknadu najmanje u iznosu polovice prosječne plaće isplaćene radniku u tri mjeseca prije prestanka ugovora o radu. Naknadu je poslodavac dužan isplatiti radniku najkasnije do petnaestog u mjesecu za prethodni mjesec. Ako je dio plaće radnika namijenjen za pokriće određenih troškova u vezi s obavljanjem rada, naknada se može razmjerno umanjiti." },
              ]
            },
            {
              parts: [
                { type: "text", content: "Radnik svojim potpisom potvrđuje da se u vrijeme zasnivanja radnog odnosa s Poslodavcem ne bavi obavljanjem poslova iz djelatnosti Poslodavca. " },
                { type: "text", content: "Radnik se obvezuje da se neće u razdoblju od dvije godine nakon prestanka ugovora o radu zaposliti kod druge osobe koja je u tržišnom natjecanju s Poslodavcem te da neće za svoj račun ili za račun treće osobe sklapati poslove kojima se natječe s Poslodavcem. " },
                { type: "text", content: "U slučaju da Radnik postupi protivno prethodnoj rečenici ovoga članka obvezuje se Poslodavcu isplatiti ugovornu kaznu u iznosu od " },
                { type: "input", value: "", required: true },
                { type: "text", content: "kn.", help: "Ugovorna kazna može se ugovoriti i za slučaj da poslodavac ne preuzme obvezu isplate naknade plaće za vrijeme trajanja ugovorne zabrane natjecanja, ako je u vrijeme sklapanja takvog ugovora radnik primao plaću veću od prosječne plaće u Republici Hrvatskoj." },
              ]
            }],
          value: "",
        }
      ]
    },
    {
      title: "POSLOVNA TAJNA",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          required: true,
          editable: true,
          content: `Radnik je dužan za vrijeme trajanja rada i nakon prestanka rada kod Poslodavca, kao poslovnu tajnu, čuvati podatke o svim značajnijim pitanjima poslovanja, a poglavito podatke o poslovnom ili proizvodnom programu i postupcima, osobne podatke radnika, podatke o prihodima te sve druge podatke čije bi odavanje neovlaštenoj osobi moglo Poslodavcu prouzročiti materijalnu ili drugu štetu. \r\nNavedeni podaci smatraju se poslovnom tajnom.\r\nRadnik ne smije iz poslovnih prostorija iznositi poslovne dokumente i sl., te ne smije takve dokumente koji se smatraju poslovnom tajnom neovlašteno koristiti, davati na uvid ili na drugi način učiniti dostupnim trećoj osobi bez posebnog odobrenja Poslodavca.\r\nU slučaju kršenju poslovne tajne, Radnik će biti dužan naknaditi Poslodavcu stvarnu štetu i izmaklu korist.`,
          help: "Poslovnom tajnom treba smatrati sve istinite, ali nepoznate podatke o nekim činjenicama, stanjima, postupcima ili sredstvima iz poslovnog života poslodavca. Kako se poslovne informacije, dokumenti i drugo ne smiju neovlašteno otkrivati, poslodavac može pravilnikom o radu ili svojom odlukom odnosno ugovorom o radu odrediti koji se sve podaci smatraju poslovnom tajnom. Objavljivanjem određenog podatka, odnosno poslovne tajne poslodavcu bi mogla nastati šteta te nastupiti štetne posljedice za njegovo poslovanje."
        }]
    },
    {
      title: "POVRAT DOKUMENTACIJE I RADNIH SREDSTAVA",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          required: true,
          editable: true,
          content: "Po prestanku ovog Ugovora, Radnik je dužan vratiti Poslodavcu svu poslovnu dokumentaciju koja se kod njega nalazi, kao i svu informatičku opremu te druga sredstva rada koju mu je Poslodavac ustupio za obavljanje poslova iz ovog Ugovoru o radu.",
        },
      ]
    },
    {
      title: "TROŠKOVI EDUKACIJE",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          required: true,
          editable: true,
          content: `Radnik se potpisom ovog Ugovora obvezuje Poslodavcu vratiti ukupne troškove edukacije nastale u razdoblju od dvije godine prije dana prestanka radnog odnosa i to u roku od 15 dana od dana prestanka radnog odnosa.\r\nUkoliko u navedenom roku Radnik ne podmiri sva dospjela dugovanja, početi će se obračunavati zakonska zatezna kamata.\r\nTroškovi edukacije iz stavka 1. ovog članka koje je Radnik dužan vratiti, utvrđuju se prema evidenciji realizirane edukacije Radnika i prema stvarnoj cijeni ostvarene edukacije uključujući popratne realizirane troškove Poslodavca vezane uz edukaciju (trošak prijevoza, smještaja i sl.).\r\nU slučaju specifičnog stručnog usavršavanja Radnika, prava i obveze ugovornih strana urediti će se posebnim ugovorom.`,
        }]
    },
    {
      title: "IZUMI, TEHNIČKA UNAPRJEĐENJA, AUTORSKA PRAVA",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: `Izumi i tehnička unapređenja ostvareni na radu ili u svezi s radom pripadaju Poslodavcu. Radnik ovim Ugovorom o radu osniva u korist Poslodavca  isključivo, sadržajno, vremenski i prostorno neograničeno pravo iskorištavanja (osobito uključujući pravo reproduciranja, distribucije, priopćavanja javnosti te prerade) autorskih djela nastalih izvršavanjem obveza iz ovog Ugovora od strane Radnika (uključujući računalne programe, računalni kod i sve druge materijale vezane uz posao iz ovog Ugovora) bez posebne naknade odnosno obvezuje se osigurati sve potrebno da se pravo iskorištavanja osnuje u korist Poslodavca, bez  posebne naknade.\r\nPoslodavac ima isključivo pravo iskorištavati navedena autorska djela bez odobrenja Radnika te se smatra da je autorsko djelo stvoreno u izvršavanju obveza Radnika i prema uputama Poslodavca. Radnik se ovime odriče bilo kakve naknade ili drugih prava vezanih uz autorska prava na autorskim djelima iz prethodnog stavka ovog članka.`,
          help: "S obzirom na odredbe Zakona o autorskom pravu i srodnim pravima, prepuruča se odnose u pogledu autorskog prava na djelu regulirati ugovorom o radu.",
        }]
    },
    {
      title: "ZAŠTITA OSOBNIH PODATAKA - GDPR",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          help: "Primjer dokumenta kojim poslodavac, u trenutku prikupljanja podataka informira radnika u skladu s Općom uredbom o zaštiti podataka, možete vidjeti u grupi dokumenata GDPR, pod nazivom Informacije kod prikupljanja podataka.",
          content: "Poslodavac prikuplja, obrađuje i koristi osobne podatke Radnika radi ostvarivanja prava i obveza iz radnog odnosa odnosno u vezi s radnim odnosom, u skladu sa Zakonom o radu, drugim zakonima i podzakonskim aktima te Pravilnikom o radu. \r\nRadnik svojim potpisom na ovom Ugovoru potvrđuje da je od strane Poslodavca obaviješten o tome da je pružanje nekih/svih osobnih podataka koji se odnose na:\r\n- ime i prezime,\r\n- adresu, \r\n- osobni identifikacijski broj i/ili drugi identifikacijski broj,\r\n- datum rođenja / JMBG, \r\n- osobni broj iz e-radne knjižice,\r\n- broj tekućeg ili žiro-računa,\r\n- dokaz o završenom školovanju (svjedodžba, diploma i sl.), \r\n- uvjerenje o zdravstvenoj sposobnosti i sl.,\r\npreduvjet za sklapanje i izvršenje Ugovora o radu odnosno svih obveza iz radnog odnosa te je navedene podatke u tom smislu Radnik pružio Poslodavcu, a u slučaju odbijanja davanja takvih osobnih podataka, Radnik ne bi mogao biti prijavljen na obvezna osiguranja odnosno ostvariti svoja ostala prava iz radnog odnosa. \r\nOsim toga, Radnik svojim potpisom na ovom Ugovoru potvrđuje da mu je Poslodavac dostavio informacije koje je dužan dostaviti u trenutku prikupljanja gore navedenih osobnih podataka, a prema Općoj uredbi o zaštiti podataka i to:\r\n- identitet i kontaktne podatke voditelja obrade odnosno predstavnika voditelja obrade, \r\n- svrhe obrade radi kojih se upotrebljavaju osobni podaci, kao i pravnu osnovu za obradu, \r\n- primatelje ili kategorije primatelja osobnih podataka, \r\n- razdoblje u kojem će osobni podaci biti pohranjeni ili, ako to nije moguće, kriterije kojima se utvrdilo to razdoblje, \r\n- postojanje prava da se od voditelja obrade zatraži pristup osobnim podacima i ispravak ili brisanje osobnih podataka ili ograničavanje obrade koji se odnose na ispitanika ili prava na ulaganje prigovora na obradu takvih te prava na prenosivost podataka, \r\n- pravo na podnošenje prigovora nadzornom tijelu (Agencija za zaštitu osobnih podataka). \r\nU tom smislu, Radnik svojim potpisom potvrđuje da mu je u trenutku prikupljanju osobnih podataka Poslodavac pružio gore navedene informacije na način da je Radniku omogućen uvid u dokument: Informacije kod prikupljanja osobnih podataka.\r\nOsim podataka koji se obrađuju u skladu s prethodnim odredbama ovog članka, Poslodavac može prikupljati i obrađivati i druge osobne podatke Radnika, ali u tom slučaju za takvu obradu mora od Radnika dobiti izričitu i jasnu privolu.\r\nAko se obrada osobnih podataka Radnika temelji na privoli, Radnik može u bilo kojem trenutku povući takvu privolu sukladno Općoj uredbi o zaštiti osobnih podataka. ",
        },
      ]
    },
     {
      title: "PODACI O SLUŽBENIKU ZA ZAŠTITU OSOBNIH PODATAKA",
      mandatory: false,
      exampleContent: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          help: "Ovaj stavak upisujete u slučaju da je poslodavac imenovao službenika za zaštitu osobnih podataka. Slučajevi u kojima je imenovanje službenika za zaštitu podataka obvezno propisani su Općom uredbom o zaštiti podataka.",
          content: "Osim toga, Poslodavac je Radniku dostavio i kontaktne podatke službenika za zaštitu osobnih podataka.",
        },
      ]
    },
    {
      title: "ZAVRŠNE ODREDBE",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: `Ovaj Ugovor se primjenjuje od dana potpisivanja.\r\nIzmjene i dopune ovog Ugovora moraju biti u pisanom obliku.\r\nEventualne sporove nastale u vezi s Ugovorom, Poslodavac i Radnik pokušati će riješiti sporazumno, u protivnom, nadležan je stvarno nadležni sud prema sjedištu Poslodavca.`,
        }]
    },
    {
      title: 'PRIMJERCI UGOVORA',
      mandatory: false,
      statements: [
          {
              type: 'text',
              required: false,
              mandatory: true,
              editable: true,
              content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
              value: '',
          }],
    },
  {
    mandatory: true,
    static: true,
    type: 2, // date and place
    statements: [
      {
        type: "input",
        mandatory: true,
        parts: [
          {
            type: "text",
            content: "U"
          },
          {
            type: "input",
            value: "",
            placeholder: "Upišite mjesto.",
            required: true,
          },
          {
            type: "text",
            content: ", dana"
          },
          {
            type: "date",
            value: new Date(),
            required: true
          },
          {
            type: "text",
            content: "godine."
          }
        ]
      },
    ]
  },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
    }
  ],
};


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/4_ugovor_o_radu_odredjeno_dodatno.ts